export const TEXT_ACCENT_CLASS: Record<string, string> = {
  'mbc-orange': 'text-mbc-orange',
  'mbc-orangel': 'text-mbc-orangel',
  'mbc-bluel': 'text-mbc-bluel',
  'mbc-mute': 'text-mbc-mute',
  'mbc-soft': 'text-mbc-soft',
  'amber-300': 'text-amber-300',
  'amber-400': 'text-amber-400',
  'emerald-300': 'text-emerald-300',
  'emerald-400': 'text-emerald-400',
  'rose-300': 'text-rose-300',
  'rose-400': 'text-rose-400',
  'sky-300': 'text-sky-300',
  'slate-300': 'text-slate-300',
  'slate-400': 'text-slate-400',
  white: 'text-white',
};

export function textAccentClass(accent?: string, fallback = 'text-mbc-orange') {
  if (!accent) return fallback;
  return TEXT_ACCENT_CLASS[accent] ?? fallback;
}
